
/* eslint-disable max-len */
const Course = () => (
  <svg id="Art" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2">
    <path d="M8,5h8.5c1.93,0,3.5,1.57,3.5,3.5h0c0,1.93-1.57,3.5-3.5,3.5H7.5c-1.93,0-3.5,1.57-3.5,3.5h0c0,1.93,1.57,3.5,3.5,3.5h8.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="5.5" cy="5" r="2.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="18.5" cy="19" r="2.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Course;
